import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import Banner from "./components/Banner";
import General from "./components/General";
import Notification from "./components/Notification";
import Project from "./components/Project";
import Storage from "./components/Storage";
import { fetchData } from "../../../services/ApiFetching";

const ProfileOverview = () => {
  const { id } = useParams(); 
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchUser = async () => {
      if (id) {
        try {
          const data = await fetchData(`users/${id}`);
          setUser(data);
        } catch (error) {
          setError(error.message || "Failed to load data.");
        } finally {
          setLoading(false);
        }
      } else {
        // Use localStorage fallback if no ID
        setUser({
          username: localStorage.getItem("username"),
          role: localStorage.getItem("role"),
          email: localStorage.getItem("email"),
        });
        setLoading(false)
      }
    };

    fetchUser();
  }, [id]);

  if (error) {
    return <div style={{ color: 'red' }}>{error}</div>;
  }

  if (loading) return <div>Loading Profile...</div>;

  return (
    <div className="flex w-full flex-col gap-5">
      <div className="w-ful mt-3 flex h-fit flex-col gap-5 lg:grid lg:grid-cols-12">
        <div className="col-span-4 lg:!mb-0">
          <Banner username={user.username} role={user.role} />
        </div>
        <div className="col-span-3 lg:!mb-0">
          <Storage />
        </div>
        <div className="z-0 col-span-5 lg:!mb-0">
          <General email={user.email} />
        </div>
      </div>

      <div className="grid h-full grid-cols-1 gap-5 lg:grid-cols-12">
        <div className="col-span-5 lg:col-span-6 lg:mb-0 3xl:col-span-4">
          <Project />
        </div>
        <div className="col-span-5 lg:col-span-12 lg:mb-0 3xl:col-span-8">
          <Notification />
        </div>
      </div>
    </div>
  );
};

export default ProfileOverview;
